<template>
  <el-dialog
    class="k-user-challenge"
    title="Челленджи пользователя"
    :close-on-click-modal="false"
    :center="true" :show-close="false"
    :visible.sync="dialogFormVisible"
  >
    <div class="k-user-challenge__container">
      <el-table class="k-users-list" :data="challenges" style="width: 100%">
        <el-table-column prop="id" label="id" width="210" ></el-table-column>
        <el-table-column prop="name" label="Имя"></el-table-column>
        <el-table-column prop="description" label="Описание"></el-table-column>
        <el-table-column prop="amount" label="Сумма"></el-table-column>
        <el-table-column label="Править" width="80">
          <template slot-scope="scope">
            <el-tooltip content="Редактировать" placement="top">
              <el-button @click="handleEdit(scope.row)" type="success" icon="el-icon-edit" circle size="mini"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-row :gutter="20" class="k-user-challenge__param">
      <el-button round @click="handleCancel" size="medium">Отмена</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'k-user-challenges-list',

  props: {
    dialogFormVisible: {
      type: Boolean,
      required: true,
    },
    userChallenge: {
      type: String,
    },
    challenges: {
      type: Array,
    },
  },

  data() {
    return {
      loader: false,
      challenge: {},
      updateChallengeForm: false,
    };
  },

  created() {},

  methods: {
    // Отмена редактирования
    handleCancel() {
      this.$emit('cancel');
    },

    // Редактирование челленджа
    handleEdit(challenge) {
      this.$emit('updateChallenge', challenge);
    },

    ...mapActions({
      setImage: 'user/setImage',
    }),
  },

  components: {
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';


.k-user-challenge {
  $this: &;
  $icon-size: 50px;

  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__title {
    margin-bottom: 2 * $vp;
  }

  &__param {
    //margin-bottom: $vp;
    text-align: center;
  }

  .el-table .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
